import { Routes } from "@angular/router";
import { validateTransferGuard } from "@core/auth/guards/validate-transfer.guard";
import { authGuardActivate } from "@core/auth/guards/auth.guard";

export const routes: Routes = [
  {
    path: "painel",
    loadComponent: () =>
      import("../layouts/layout-private/layout-private.component").then((m) => m.LayoutPrivateComponent),
    canActivate: [validateTransferGuard, authGuardActivate],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./private.routes").then((r) => r.privateRoutes),
      },
    ],
  },
  {
    path: "",
    loadChildren: () =>
      import("../features/auth/auth.routes").then((r) => r.publicRoutes),
  },
  { path: "**", redirectTo: "/login" },
];
